import {
  getUserProfile,
  GET_USER_PROFILE_MESSAGE_TYPE,
} from '@leagueplatform/user-profile-api';
import { useQuery } from '@tanstack/react-query';

export const useGetUserProfile = () =>
  useQuery({
    queryKey: [GET_USER_PROFILE_MESSAGE_TYPE],
    queryFn: () => getUserProfile(),
  });
